import { FC } from "react";
import { MiModal } from "@miplatform/components";
import { ButtonVariants, Colors } from "@miplatform/types";
import { mdiAlertCircleOutline } from "@mdi/js";
import { useNavBlocker } from "../../hooks";

interface PendingChangesModalProps {
  blocker: ReturnType<typeof useNavBlocker>;
  isSaveDisabled?: boolean;
  onSave?: () => void | Promise<void>;
}

export const PendingChangesModal: FC<PendingChangesModalProps> = ({
  blocker,
  isSaveDisabled = false,
  onSave,
}) => {
  if (blocker.state !== "blocked") return null;

  const handleSave = () => {
    onSave?.();
    blocker.proceed?.();
  };

  const actions = [
    {
      name: "Cancel",
      variant: ButtonVariants.Text,
      color: Colors.Black,
      onClick: () => blocker.reset?.(),
    },
    {
      name: "Discard Changes",
      variant: ButtonVariants.Outlined,
      color: Colors.Red,
      onClick: blocker.proceed,
    },

    {
      name: "Save Changes",
      color: Colors.Primary,
      variant: ButtonVariants.Contained,
      onClick: handleSave,
      disabled: isSaveDisabled,
    },
  ];

  return (
    <MiModal
      open={blocker.state === "blocked"}
      title="Unsaved Changes"
      width={448}
      titleIcon={mdiAlertCircleOutline}
      closeModal={() => blocker.reset?.()}
      description="If you leave this page, your changes will be lost"
      actions={actions}
    />
  );
};
